import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MaterialIcon from "../../../shared/components/MaterialIcon";
import { useTranslation } from "../../../i18n";
import { fetchAdminOfferCustomers, formatOfferPrice } from "../adminOffersApi";
import { OfferStatusBadge } from "../pages/AdminCustomOffersPage";

/** Custom-offer summary on the admin user detail page (account owners only). */
const AdminUserOfferCard = ({ userId }) => {
  const { t, locale } = useTranslation();
  const [row, setRow] = useState(undefined); // undefined = loading

  useEffect(() => {
    let active = true;
    fetchAdminOfferCustomers({ userId })
      .then((data) => {
        if (active) setRow(data.results[0] || null);
      })
      .catch(() => {
        if (active) setRow(null);
      });
    return () => {
      active = false;
    };
  }, [userId]);

  const offer = row?.currentOffer || null;

  return (
    <section className="tonal-card mt-stack-lg rounded-xl border border-outline-variant/30 p-stack-lg">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h2 className="font-headline-md text-primary">{t("adminOffers.userCard.title")}</h2>
          {row === undefined ? (
            <div className="mt-2 h-4 w-48 animate-pulse rounded bg-surface-container-high" />
          ) : offer ? (
            <p className="mt-1 flex flex-wrap items-center gap-2 text-body-md text-on-surface">
              <OfferStatusBadge status={offer.status} t={t} />
              <span className="font-mono text-[12px] text-on-surface-variant">{offer.reference}</span>
              <span className="font-semibold">{offer.title}</span>
              <span className="text-on-surface-variant">
                · {formatOfferPrice(offer.price, locale)} {t(`customOffer.interval.${offer.billingInterval}`)}
              </span>
            </p>
          ) : (
            <p className="mt-1 text-body-md text-on-surface-variant">{t("adminOffers.userCard.none")}</p>
          )}
        </div>
        <Link
          to={`/dashboard/admin/custom-offers?user=${userId}`}
          className="inline-flex shrink-0 items-center gap-1.5 rounded-full border border-secondary/40 bg-secondary/5 px-4 py-2 text-label-sm font-semibold text-secondary transition hover:bg-secondary/10"
        >
          <MaterialIcon name={offer ? "workspace_premium" : "add"} className="text-[16px]" />
          {offer ? t("adminOffers.userCard.manageCta") : t("adminOffers.userCard.createCta")}
        </Link>
      </div>
    </section>
  );
};

export default AdminUserOfferCard;
